import { useEffect, useState } from 'react';
import styles from './Header.module.css';

const navItems = [
  { label: 'Clientes', href: '#clientes' },
  { label: 'Como funciona', href: '#como-funciona' },
  { label: 'Vantagens', href: '#vantagens' },
  { label: 'Depoimentos', href: '#depoimentos' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={styles.header} role="banner">
      <div className={styles.container}>
        <div className={styles.brand}>
          <img src="/logo.png" alt="Logo DJ DevStudio" className={styles.logo} />
          <span className={styles.title}>João Victor</span>
        </div>

        <nav className={styles.nav} aria-label="Principal navigation">
          <ul className={styles.navList}>
            {navItems.map(item => (
              <li key={item.href} className={styles.navItem}>
                <a className={styles.navLink} href={item.href}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* CTA / botão de mensagem no lado direito */}
        <div className={styles.actions}>
          <a
            className={styles.cta}
            href="https://wa.me/5535999564940?text=Ol%C3%A1%21%20Acabei%20de%20visitar%20o%20site%20da%20DJ%20DevStudio%20e%20quero%20conversar%20sobre%20um%20projeto."
            role="button"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/whats.png" alt="WhatsApp" className={styles.whatsIcon} />
            <span className={styles.ctaText}>Envie-me uma mensagem!</span>
          </a>
        </div>

        <button
          type="button"
          className={styles.menuToggle}
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label="Abrir menu de navegação"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div
        className={menuOpen ? `${styles.mobileBackdrop} ${styles.mobileBackdropVisible}` : styles.mobileBackdrop}
        onClick={closeMenu}
        aria-hidden="true"
      />

      <nav
        className={menuOpen ? `${styles.mobileNav} ${styles.mobileNavOpen}` : styles.mobileNav}
        aria-label="Menu móvel"
      >
        <ul>
          {navItems.map(item => (
            <li key={`mobile-${item.href}`}>
              <a href={item.href} onClick={closeMenu}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          className={styles.mobileCta}
          href="https://wa.me/5535999564940?text=Ol%C3%A1%21%20Acabei%20de%20visitar%20o%20site%20da%20DJ%20DevStudio%20e%20quero%20conversar%20sobre%20um%20projeto."
          target="_blank"
          rel="noreferrer"
          onClick={closeMenu}
        >
          Conversar no WhatsApp
        </a>
      </nav>
    </header>
  );
}
